var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCru(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 46,
    viewBox: "0 0 51 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.684 28.9393C27.4324 27.9098 28.0501 26.8575 29.0795 26.583C30.109 26.3313 31.1613 26.949 31.4358 27.9784C31.6875 29.0079 31.0698 30.0602 30.0403 30.3347C28.988 30.6093 27.9357 29.9916 27.684 28.9393Z",
    fill: "url(#paint0_linear_32722_38690)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9656 25.3701C36.4918 24.4779 36.1944 23.3112 35.3022 22.785C34.41 22.2589 33.2433 22.5563 32.7172 23.4484C32.191 24.3406 32.4884 25.5074 33.3806 26.0335C34.2728 26.5826 35.4395 26.2852 35.9656 25.3701Z",
    fill: "url(#paint1_linear_32722_38690)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1092 17.9581C36.9719 16.9515 36.034 16.2423 35.0274 16.4025C34.0209 16.5397 33.3117 17.4777 33.4718 18.4843C33.6091 19.4908 34.547 20.2 35.5536 20.0399C36.5602 19.9026 37.2465 18.9647 37.1092 17.9581Z",
    fill: "url(#paint2_linear_32722_38690)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7006 11.3928C33.0372 10.6378 31.9162 10.5692 31.1613 11.2326C30.4064 11.896 30.3377 13.017 31.0012 13.7719C31.6646 14.5269 32.7856 14.5955 33.5405 13.9321C34.2954 13.2686 34.364 12.1477 33.7006 11.3928Z",
    fill: "url(#paint3_linear_32722_38690)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4553 7.64058C26.5403 7.34318 25.5566 7.82359 25.2363 8.73866C24.9389 9.65373 25.4193 10.6374 26.3344 10.9577C27.2494 11.2551 28.2331 10.7747 28.5534 9.85963C28.8737 8.92168 28.3704 7.93798 27.4553 7.64058Z",
    fill: "url(#paint4_linear_32722_38690)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5923 10.7061C21.5272 10.7061 22.2852 9.94815 22.2852 9.0132C22.2852 8.07824 21.5272 7.32031 20.5923 7.32031C19.6573 7.32031 18.8994 8.07824 18.8994 9.0132C18.8994 9.94815 19.6573 10.7061 20.5923 10.7061Z",
    fill: "url(#paint5_linear_32722_38690)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8434 10.1345C13.0885 10.6378 12.8826 11.6673 13.3859 12.4451C13.8891 13.2 14.9186 13.4059 15.6964 12.9026C16.4513 12.3993 16.6572 11.3699 16.1539 10.5921C15.6278 9.81425 14.5983 9.63123 13.8434 10.1345Z",
    fill: "url(#paint6_linear_32722_38690)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17648 15.3959C8.71895 16.1508 8.94771 17.1574 9.70264 17.6149C10.4576 18.0725 11.4642 17.8437 11.9217 17.0888C12.3792 16.3338 12.1504 15.3273 11.3955 14.8697C10.6177 14.3893 9.63402 14.641 9.17648 15.3959Z",
    fill: "url(#paint7_linear_32722_38690)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91217 21.9157C6.72915 22.7621 7.2782 23.5857 8.12464 23.7687C8.97108 23.9517 9.79464 23.4026 9.97765 22.5562C10.1607 21.7098 9.61162 20.8862 8.76518 20.7032C7.91875 20.5202 7.09518 21.0692 6.91217 21.9157Z",
    fill: "url(#paint8_linear_32722_38690)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16332 28.8249C7.32346 29.6485 8.10127 30.1975 8.92483 30.0374C9.7484 29.8773 10.2974 29.0995 10.1373 28.2759C9.97716 27.4523 9.19936 26.9033 8.37579 27.0634C7.55223 27.2236 7.02606 28.0014 7.16332 28.8249Z",
    fill: "url(#paint9_linear_32722_38690)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95459 35.2529C10.3664 35.9392 11.2814 36.168 11.9677 35.7562C12.654 35.3444 12.8828 34.4293 12.471 33.743C12.0592 33.0567 11.1442 32.828 10.4579 33.2397C9.77157 33.6515 9.54281 34.5437 9.95459 35.2529Z",
    fill: "url(#paint10_linear_32722_38690)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6899 40.2401C15.3075 40.7434 16.1997 40.6519 16.703 40.0342C17.2063 39.4166 17.1148 38.5244 16.4971 38.0211C15.8795 37.5178 14.9873 37.6093 14.484 38.227C13.9807 38.8446 14.0722 39.7368 14.6899 40.2401Z",
    fill: "url(#paint11_linear_32722_38690)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6378 43.397C21.347 43.6944 22.1477 43.3513 22.4451 42.6421C22.7425 41.9329 22.3993 41.1322 21.6901 40.8348C20.981 40.5374 20.1803 40.8806 19.8829 41.5898C19.6084 42.2989 19.9286 43.0996 20.6378 43.397Z",
    fill: "url(#paint12_linear_32722_38690)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4323 44.564C28.1643 44.6097 28.8049 44.0378 28.8277 43.3058C28.8735 42.5737 28.3016 41.9332 27.5695 41.9103C26.8375 41.8645 26.1969 42.4364 26.174 43.1685C26.1283 43.9006 26.6773 44.5182 27.4323 44.564Z",
    fill: "url(#paint13_linear_32722_38690)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9979 43.6032C34.6842 43.443 35.1417 42.7567 34.9816 42.0704C34.8214 41.3841 34.1351 40.9266 33.4488 41.0867C32.7625 41.2469 32.305 41.9332 32.4651 42.6195C32.6253 43.3287 33.3116 43.7633 33.9979 43.6032Z",
    fill: "url(#paint14_linear_32722_38690)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3119 40.7437C40.9067 40.3777 41.0897 39.6228 40.7237 39.028C40.3577 38.4332 39.6027 38.2502 39.0079 38.6162C38.4131 38.9822 38.2301 39.7371 38.5962 40.3319C38.9622 40.9267 39.74 41.1097 40.3119 40.7437Z",
    fill: "url(#paint15_linear_32722_38690)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1844 36.2594C45.6191 35.779 45.5962 35.0241 45.0929 34.5666C44.6125 34.1319 43.8576 34.1548 43.4001 34.6581C42.9654 35.1385 42.9883 35.8934 43.4916 36.3509C43.972 36.7856 44.7269 36.7398 45.1844 36.2594Z",
    fill: "url(#paint16_linear_32722_38690)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7993 30.609C49.0738 30.0371 48.8451 29.3508 48.296 29.0763C47.7241 28.8018 47.0378 29.0305 46.7633 29.5796C46.4888 30.1515 46.7175 30.8378 47.2666 31.1123C47.8385 31.4097 48.5248 31.1809 48.7993 30.609Z",
    fill: "url(#paint17_linear_32722_38690)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7665 24.2037C50.9038 23.6089 50.5149 23.0141 49.943 22.8997C49.3482 22.7625 48.7534 23.1514 48.639 23.7233C48.5017 24.3181 48.8906 24.9129 49.4626 25.0273C50.0573 25.1874 50.6293 24.7985 50.7665 24.2037Z",
    fill: "url(#paint18_linear_32722_38690)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9951 17.5924C50.9723 17.0204 50.469 16.5629 49.8971 16.5858C49.3251 16.6087 48.8676 17.112 48.8905 17.6839C48.9133 18.2558 49.4166 18.7133 49.9886 18.6904C50.5605 18.6676 51.018 18.1872 50.9951 17.5924Z",
    fill: "url(#paint19_linear_32722_38690)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.463 11.0037C49.3029 10.4775 48.731 10.1801 48.2048 10.3402C47.6787 10.5004 47.3813 11.0723 47.5414 11.5984C47.7015 12.1246 48.2735 12.422 48.7996 12.2619C49.3258 12.1017 49.6232 11.5298 49.463 11.0037Z",
    fill: "url(#paint20_linear_32722_38690)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3516 5.21567C46.0542 4.78101 45.4594 4.66662 45.0247 4.96402C44.5901 5.26142 44.4757 5.85621 44.7731 6.29087C45.0705 6.72552 45.6653 6.83992 46.1 6.54252C46.5346 6.24512 46.649 5.65033 46.3516 5.21567Z",
    fill: "url(#paint21_linear_32722_38690)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3643 1.83014C41.8697 1.83014 42.2794 1.42045 42.2794 0.915069C42.2794 0.40969 41.8697 0 41.3643 0C40.8589 0 40.4492 0.40969 40.4492 0.915069C40.4492 1.42045 40.8589 1.83014 41.3643 1.83014Z",
    fill: "url(#paint22_linear_32722_38690)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9353 14.6641C19.8601 14.9386 19.1967 16.0367 19.4712 17.1119C19.7457 18.1871 20.8438 18.8505 21.919 18.576C22.9942 18.3015 23.6576 17.2034 23.3831 16.1282C23.1315 15.053 22.0334 14.3896 20.9353 14.6641Z",
    fill: "url(#paint23_linear_32722_38690)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.964 19.6738C14.415 20.6117 14.7124 21.8242 15.6503 22.3732C16.5883 22.9223 17.8007 22.6249 18.3498 21.6869C18.8988 20.749 18.6014 19.5365 17.6635 18.9875C16.7255 18.4384 15.5131 18.7358 14.964 19.6738Z",
    fill: "url(#paint24_linear_32722_38690)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7978 27.1547C13.9579 28.207 14.9187 28.9391 15.9711 28.8018C17.0234 28.6417 17.7555 27.6808 17.6182 26.6285C17.4581 25.5762 16.4972 24.8441 15.4449 24.9814C14.3926 25.1415 13.6605 26.1023 13.7978 27.1547Z",
    fill: "url(#paint25_linear_32722_38690)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2294 33.766C17.9157 34.5438 19.1053 34.6124 19.8831 33.949C20.6609 33.2627 20.7295 32.0731 20.0661 31.2953C19.3798 30.5175 18.1902 30.4488 17.4124 31.1122C16.6117 31.7985 16.5431 32.9881 17.2294 33.766Z",
    fill: "url(#paint26_linear_32722_38690)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5205 37.5407C24.4813 37.8609 25.5108 37.3348 25.8311 36.3968C26.1514 35.436 25.6252 34.4065 24.6872 34.0863C23.7264 33.766 22.697 34.2921 22.3767 35.2301C22.0335 36.1909 22.5597 37.2204 23.5205 37.5407Z",
    fill: "url(#paint27_linear_32722_38690)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6576 37.8608C31.6184 37.7235 32.3047 36.8314 32.1675 35.8477C32.0302 34.8868 31.138 34.2005 30.1543 34.3378C29.1935 34.4751 28.5072 35.3673 28.6444 36.351C28.7817 37.3118 29.6968 37.9981 30.6576 37.8608Z",
    fill: "url(#paint28_linear_32722_38690)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1778 35.0242C37.9556 34.498 38.1844 33.4228 37.6353 32.6221C37.0863 31.8214 36.0339 31.6156 35.2333 32.1646C34.4554 32.6908 34.2267 33.766 34.7757 34.5666C35.3248 35.3445 36.4 35.5503 37.1778 35.0242Z",
    fill: "url(#paint29_linear_32722_38690)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4493 30.5407C41.3716 30.5407 42.1193 29.793 42.1193 28.8707C42.1193 27.9484 41.3716 27.2007 40.4493 27.2007C39.527 27.2007 38.7793 27.9484 38.7793 28.8707C38.7793 29.793 39.527 30.5407 40.4493 30.5407Z",
    fill: "url(#paint30_linear_32722_38690)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1325 23.197C44.3155 22.3277 43.7436 21.4584 42.8742 21.2753C42.0049 21.0923 41.1356 21.6643 40.9526 22.5336C40.7696 23.4029 41.3415 24.2722 42.2108 24.4552C43.103 24.6382 43.9494 24.0663 44.1325 23.197Z",
    fill: "url(#paint31_linear_32722_38690)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8804 16.2656C43.7203 15.4192 42.8967 14.8472 42.0503 15.0074C41.2038 15.1675 40.6319 15.9911 40.792 16.8375C40.9522 17.6839 41.7757 18.2559 42.6222 18.0957C43.4686 17.9356 44.0405 17.112 43.8804 16.2656Z",
    fill: "url(#paint32_linear_32722_38690)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7628 12.1247C40.5967 12.1247 41.2727 11.4487 41.2727 10.6148C41.2727 9.78096 40.5967 9.10498 39.7628 9.10498C38.9289 9.10498 38.2529 9.78096 38.2529 10.6148C38.2529 11.4487 38.9289 12.1247 39.7628 12.1247Z",
    fill: "url(#paint33_linear_32722_38690)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3312 4.82702C35.7136 4.30085 34.7756 4.39235 34.2723 5.0329C33.7462 5.65057 33.8377 6.58852 34.4782 7.0918C35.0959 7.61797 36.0338 7.52647 36.5371 6.88592C37.0404 6.24537 36.9718 5.35318 36.3312 4.82702Z",
    fill: "url(#paint34_linear_32722_38690)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3833 1.66993C29.6512 1.37254 28.8277 1.71568 28.5303 2.44773C28.2329 3.17979 28.576 4.00336 29.3081 4.30076C30.0402 4.59815 30.8637 4.255 31.1611 3.52294C31.4356 2.79089 31.0925 1.96733 30.3833 1.66993Z",
    fill: "url(#paint35_linear_32722_38690)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5664 0.503053C22.8114 0.457299 22.1709 1.02923 22.1251 1.78416C22.0794 2.53909 22.6513 3.17963 23.4062 3.22539C24.1612 3.27114 24.8017 2.69921 24.8475 1.94428C24.9161 1.18935 24.3213 0.548806 23.5664 0.503053Z",
    fill: "url(#paint36_linear_32722_38690)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9775 1.46411C16.2683 1.62425 15.8108 2.33343 15.9709 3.04261C16.1311 3.75179 16.8174 4.20932 17.5494 4.04918C18.2586 3.88904 18.7162 3.17987 18.556 2.47069C18.3959 1.76152 17.7096 1.30398 16.9775 1.46411Z",
    fill: "url(#paint37_linear_32722_38690)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6637 4.32373C10.0689 4.68975 9.88589 5.46756 10.2519 6.06235C10.6179 6.65715 11.3958 6.84017 11.9906 6.47414C12.5853 6.10812 12.7684 5.3303 12.4023 4.7355C12.0363 4.16359 11.2585 3.9577 10.6637 4.32373Z",
    fill: "url(#paint38_linear_32722_38690)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M5.791 8.83075C5.33347 9.33404 5.37922 10.1118 5.88251 10.5465C6.38579 11.004 7.1636 10.9583 7.59826 10.455C8.05579 9.95171 8.01004 9.1739 7.50675 8.73924C7.02634 8.28171 6.24854 8.32746 5.791 8.83075Z",
    fill: "url(#paint39_linear_32722_38690)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17633 14.4811C1.87893 15.053 2.10769 15.7622 2.70249 16.0596C3.27441 16.357 3.98358 16.1282 4.28098 15.5334C4.57838 14.9615 4.34961 14.2523 3.75482 13.9549C3.16003 13.6575 2.47373 13.9092 2.17633 14.4811Z",
    fill: "url(#paint40_linear_32722_38690)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0.209253 20.8863C0.0719922 21.4811 0.460899 22.0758 1.05569 22.2131C1.65049 22.3504 2.24528 21.9615 2.38254 21.3667C2.5198 20.7719 2.13089 20.1771 1.5361 20.0398C0.941305 19.9026 0.346513 20.2915 0.209253 20.8863Z",
    fill: "url(#paint41_linear_32722_38690)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00315482 27.5208C0.0260315 28.1155 0.529318 28.5502 1.12411 28.5273C1.71891 28.5044 2.15356 28.0012 2.13069 27.4064C2.10781 26.8116 1.60452 26.3769 1.00973 26.3998C0.414934 26.4227 -0.0425986 26.926 0.00315482 27.5208Z",
    fill: "url(#paint42_linear_32722_38690)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53575 34.1091C1.69589 34.6353 2.2678 34.9327 2.81685 34.7725C3.34301 34.6124 3.64041 34.0405 3.48027 33.4914C3.32013 32.9653 2.74822 32.6679 2.19918 32.828C1.67301 32.9882 1.35273 33.5601 1.53575 34.1091Z",
    fill: "url(#paint43_linear_32722_38690)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62467 39.8968C4.92206 40.3314 5.51686 40.4458 5.9744 40.1484C6.40906 39.851 6.52343 39.2562 6.22604 38.7987C5.92864 38.364 5.33385 38.2496 4.87631 38.547C4.44165 38.8444 4.32727 39.4621 4.62467 39.8968Z",
    fill: "url(#paint44_linear_32722_38690)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90229 44.7467C9.22257 45.1356 9.79449 45.2042 10.1834 44.8839C10.5723 44.5637 10.6409 43.9918 10.3207 43.6029C10.0004 43.2139 9.42846 43.1453 9.03955 43.4656C8.65065 43.7859 8.60489 44.3578 8.90229 44.7467Z",
    fill: "url(#paint45_linear_32722_38690)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32722_38690",
    x1: 28.1895,
    y1: 29.8453,
    x2: 30.9272,
    y2: 27.1076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32722_38690",
    x1: 32.9995,
    y1: 25.7554,
    x2: 35.6718,
    y2: 23.0831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32722_38690",
    x1: 33.9828,
    y1: 19.5147,
    x2: 36.589,
    y2: 16.9084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32722_38690",
    x1: 31.0872,
    y1: 13.8452,
    x2: 33.6278,
    y2: 11.3045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_32722_38690",
    x1: 25.6693,
    y1: 10.5339,
    x2: 28.1449,
    y2: 8.05836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32722_38690",
    x1: 19.3821,
    y1: 10.2127,
    x2: 21.7916,
    y2: 7.80321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_32722_38690",
    x1: 13.602,
    y1: 12.6798,
    x2: 15.9462,
    y2: 10.3355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_32722_38690",
    x1: 9.40959,
    y1: 17.3785,
    x2: 11.6883,
    y2: 15.0997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_32722_38690",
    x1: 7.34314,
    y1: 23.3356,
    x2: 9.55604,
    y2: 21.1227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_32722_38690",
    x1: 7.5886,
    y1: 29.6271,
    x2: 9.73586,
    y2: 27.4798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_32722_38690",
    x1: 10.1809,
    y1: 35.5332,
    x2: 12.2629,
    y2: 33.4512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_32722_38690",
    x1: 14.5804,
    y1: 40.1404,
    x2: 16.5965,
    y2: 38.1244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_32722_38690",
    x1: 20.1871,
    y1: 43.0964,
    x2: 22.138,
    y2: 41.1456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_32722_38690",
    x1: 26.5533,
    y1: 44.1792,
    x2: 28.4381,
    y2: 42.2944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_32722_38690",
    x1: 32.8153,
    y1: 43.2634,
    x2: 34.6347,
    y2: 41.4441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_32722_38690",
    x1: 38.7915,
    y1: 40.5692,
    x2: 40.5454,
    y2: 38.8153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_32722_38690",
    x1: 43.4446,
    y1: 36.303,
    x2: 45.1326,
    y2: 34.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_32722_38690",
    x1: 46.9662,
    y1: 30.911,
    x2: 48.5891,
    y2: 29.2881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_32722_38690",
    x1: 48.9154,
    y1: 24.7538,
    x2: 50.4725,
    y2: 23.1968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_32722_38690",
    x1: 49.1862,
    y1: 18.3958,
    x2: 50.6775,
    y2: 16.9045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_32722_38690",
    x1: 47.7799,
    y1: 12.0208,
    x2: 49.2058,
    y2: 10.5949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_32722_38690",
    x1: 44.8827,
    y1: 6.43307,
    x2: 46.2431,
    y2: 5.07273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_32722_38690",
    x1: 40.7197,
    y1: 1.5687,
    x2: 42.0143,
    y2: 0.274086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_32722_38690",
    x1: 20.0026,
    y1: 18.0623,
    x2: 22.8683,
    y2: 15.1967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_32722_38690",
    x1: 15.2607,
    y1: 22.0832,
    x2: 18.0552,
    y2: 19.2887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_32722_38690",
    x1: 14.3466,
    y1: 28.2552,
    x2: 17.0692,
    y2: 25.5326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_32722_38690",
    x1: 17.3109,
    y1: 33.8564,
    x2: 19.962,
    y2: 31.2053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_32722_38690",
    x1: 22.7968,
    y1: 37.0993,
    x2: 25.377,
    y2: 34.5191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_32722_38690",
    x1: 29.1525,
    y1: 37.3514,
    x2: 31.6609,
    y2: 34.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_32722_38690",
    x1: 35.0008,
    y1: 34.8167,
    x2: 37.4381,
    y2: 32.3794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_32722_38690",
    x1: 39.2617,
    y1: 30.0496,
    x2: 41.6277,
    y2: 27.6836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_32722_38690",
    x1: 41.3975,
    y1: 24.0233,
    x2: 43.6918,
    y2: 21.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_32722_38690",
    x1: 41.2196,
    y1: 17.6641,
    x2: 43.4425,
    y2: 15.4413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_32722_38690",
    x1: 38.696,
    y1: 11.6892,
    x2: 40.8478,
    y2: 9.53741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_32722_38690",
    x1: 34.3651,
    y1: 7.01318,
    x2: 36.4451,
    y2: 4.93318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_32722_38690",
    x1: 28.8265,
    y1: 3.98897,
    x2: 30.8355,
    y2: 1.97996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_32722_38690",
    x1: 22.5297,
    y1: 2.83724,
    x2: 24.4668,
    y2: 0.900147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_32722_38690",
    x1: 16.3357,
    y1: 3.68494,
    x2: 18.2016,
    y2: 1.81904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_32722_38690",
    x1: 10.428,
    y1: 6.31098,
    x2: 12.2227,
    y2: 4.51631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_32722_38690",
    x1: 5.84359,
    y1: 10.5082,
    x2: 7.56651,
    y2: 8.78529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_32722_38690",
    x1: 2.39025,
    y1: 15.8321,
    x2: 4.0422,
    y2: 14.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_32722_38690",
    x1: 0.509876,
    y1: 21.9204,
    x2: 2.09018,
    y2: 20.3401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_32722_38690",
    x1: 0.307392,
    y1: 28.21,
    x2: 1.81611,
    y2: 26.7013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_32722_38690",
    x1: 1.78247,
    y1: 34.5164,
    x2: 3.22007,
    y2: 33.0788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_32722_38690",
    x1: 4.7485,
    y1: 40.0353,
    x2: 6.11465,
    y2: 38.6692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_32722_38690",
    x1: 8.97962,
    y1: 44.8313,
    x2: 10.2743,
    y2: 43.5367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00004969,
    stopColor: "#D4A45A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2491,
    stopColor: "#EBCA7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4532,
    stopColor: "#FAE191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5797,
    stopColor: "#FFEA99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC23D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCru);
export default __webpack_public_path__ + "static/media/cru.1f151af7.svg";
export { ForwardRef as ReactComponent };